import { getAttrValue } from '@grandvisionhq/utils';

const getIsAvailableForSubscription = (variant, purchaseTypePrices)=>{
    const hasAvailableForSubscriptionAttribute = !!getAttrValue(variant, 'isAvailableForSubscription');
    const hasSubscriptionPrice = !!purchaseTypePrices['subscription-purchase'];
    if (hasAvailableForSubscriptionAttribute && !hasSubscriptionPrice) {
        console.error(`Product is available for subscription, but has no subscription price.`, {
            sku: variant.sku,
            name: variant.name
        });
        return false;
    }
    return hasAvailableForSubscriptionAttribute;
};

export { getIsAvailableForSubscription };
//# sourceMappingURL=get-is-available-for-subscription.js.map
